/**
 * Configuración de entorno — URLs derivadas del hostname (ver config/appContext.js)
 */

import { getAppContext } from '../config/appContext';

const isDevelopment = process.env.NODE_ENV === 'development';
const ctx = getAppContext();

export const environment = {
  API_URL: ctx.apiBaseUrl,
  TENANT_SLUG: ctx.tenantSlug || process.env.REACT_APP_TENANT_SLUG || null,
  APP_MODE: ctx.mode,
  TENANT_DOMAIN_SUFFIX: ctx.tenantDomainSuffix,
  API_TIMEOUT: 10000,
  DEBUG: isDevelopment,
  VERSION: '1.0.0',
};

export const API_URL = environment.API_URL;
